import { render, staticRenderFns } from "./asset-create.vue?vue&type=template&id=a5d9b1ea&"
import script from "./asset-create.vue?vue&type=script&lang=js&"
export * from "./asset-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports